(() => {
  if (window.OriginProductAccordionsInitialized) return;
  window.OriginProductAccordionsInitialized = true;

  const disclosureSelector = '[data-origin-stable-disclosure][aria-controls]';
  const maximumStabilizationDuration = 2500;
  const requiredStableFrames = 12;
  const openingContentReveal = 200;
  const viewportBottomInset = 80;

  document.addEventListener(
    'click',
    (event) => {
      if (!(event.target instanceof Element)) return;

      const trigger = event.target.closest(disclosureSelector);
      if (!trigger) return;

      const productInfo = trigger.closest('.product-info');
      if (!productInfo || window.getComputedStyle(productInfo).position !== 'sticky') return;

      const contentId = trigger.getAttribute('aria-controls');
      const content = contentId ? document.getElementById(contentId) : null;
      if (!content) return;

      const triggerRect = trigger.getBoundingClientRect();
      const initialTriggerTop = triggerRect.top;
      const isOpening = trigger.getAttribute('aria-expanded') !== 'true';
      const viewportHeight = window.visualViewport?.height || window.innerHeight;
      const maximumOpeningTriggerTop =
        viewportHeight - triggerRect.height - openingContentReveal - viewportBottomInset;
      const targetTriggerTop = isOpening
        ? Math.min(initialTriggerTop, Math.max(24, maximumOpeningTriggerTop))
        : initialTriggerTop;
      const startedAt = Date.now();
      let animationFrame = 0;
      let previousContentHeight = content.getBoundingClientRect().height;
      let stableFrames = 0;
      let stopped = false;

      const keepTriggerStable = () => {
        if (stopped) return;

        const offset = trigger.getBoundingClientRect().top - targetTriggerTop;
        if (Math.abs(offset) > 0.5) {
          const root = document.documentElement;
          const previousScrollBehavior = root.style.scrollBehavior;
          root.style.scrollBehavior = 'auto';
          window.scrollBy(0, offset);
          root.style.scrollBehavior = previousScrollBehavior;
        }
      };

      const stopStabilization = () => {
        stopped = true;
        window.cancelAnimationFrame(animationFrame);
      };

      const stabilizeFrame = () => {
        if (stopped) return;

        keepTriggerStable();

        const currentContentHeight = content.getBoundingClientRect().height;
        const expansionStateMatches =
          (trigger.getAttribute('aria-expanded') === 'true') === isOpening;
        const contentStateReady = isOpening
          ? currentContentHeight > 1
          : currentContentHeight <= 1;
        const heightIsStable = Math.abs(currentContentHeight - previousContentHeight) <= 0.5;
        const triggerIsStable =
          Math.abs(trigger.getBoundingClientRect().top - targetTriggerTop) <= 0.5;

        stableFrames =
          expansionStateMatches && contentStateReady && heightIsStable && triggerIsStable
            ? stableFrames + 1
            : 0;
        previousContentHeight = currentContentHeight;

        if (
          stableFrames >= requiredStableFrames ||
          Date.now() - startedAt >= maximumStabilizationDuration
        ) {
          stopStabilization();
          return;
        }

        animationFrame = window.requestAnimationFrame(stabilizeFrame);
      };

      animationFrame = window.requestAnimationFrame(stabilizeFrame);
    },
    true
  );
})();
